module.exports = __webpack_public_path__ + "media/Horse1.3668affa.ogg";